import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { Filter } from '../../ts/helpers/Filter';
import { IListResource } from '../../ts/resources/Resource';
import { ResourceQuery } from '../../ts/resources/ResourceQuery';
import {
  GetDataConnectionTypesRequest,
  IGetDataConnectionTypesResult,
} from '../../ts/ServerApi/requests/GetDataConnectionTypesRequest';
import { IDataConnectionType } from '../../ts/ServerApi/types/IDataConnection';
import { FilterFieldNames } from '../../ts/ServerApi/types/IFilterClause';

class DataConnectionTypesResource implements IListResource<IDataConnectionType> {

  private fetcher = new WebClientListResourceFetcher(
    GetDataConnectionTypesRequest,
    (result: IGetDataConnectionTypesResult) => result.dataConnectionTypes);

  public all(): ResourceQuery<IDataConnectionType> {
    return new ResourceQuery(this.fetcher);
  }

  public getByDataConnectionType(dataConnectionType: string): Promise<IDataConnectionType> {
    return this.all()
      .withFilters([Filter.stringFieldEq(FilterFieldNames.connectionType, dataConnectionType)])
      .getFirst();
  }

}

export const DataConnectionTypes = new DataConnectionTypesResource();